import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography
} from "@mui/material";
import React from "react";

function Header() {

  return (<>
    <AppBar
      position="sticky"
      sx={{
        display: "flex",
        justifyContent: "center",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 1100,
        borderBottom: '1px solid white',
      }}
    >
      <Container maxWidth="md" sx={{
      }}>
        <Toolbar disableGutters
          sx={{
            justifyContent: { xs: "space-between" },
          }}
        >
          <Button sx={{
            minWidth: '32px',
            paddingLeft: 0,
          }}
            startIcon={<Avatar> <img src="/favicon.png" alt="logo" /></Avatar>}
            href="https://sawicka.pro"
          >
            <Typography variant='subtitle2'
              sx={{
                display: { xs: "flex", sm: "flex" },
              }}>
              ARCHITEKT SAWICKA
            </Typography>
          </Button>
          <Box
            sx={{
              display: { xs: "flex", md: "flex" },
              flexWrap: "nowrap",
              overflowX: "hidden",
            }}
          >
            <Button sx={{ minWidth: '32px', }}
              startIcon={<Avatar> <MailOutlineSharpIcon /></Avatar>}
              href="mailto:natalia@sawicka.pro?subject=Zapytanie"
            >
              <Typography variant='subtitle2'
                sx={{
                  display: { xs: "none", md: "flex" },
                }}>
                natalia@sawicka.pro
              </Typography>
            </Button>
            <Button sx={{ minWidth: '32px', paddingRight: 0 }}
              startIcon={<Avatar sx={{ m: 0 }}><CallOutlinedIcon /></Avatar>}
              href="tel:+48726849319"
            >
              <Typography variant='subtitle2'
                align='right'
                sx={{
                  display: { xs: "none", sm: "flex" },
                }}>
                726 849 319
              </Typography>
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar >
  </>
  );
}

export default Header;
